export const isUrlExternal = (url?: string): boolean =>
	!!url
	&& (url?.startsWith('http://')
		|| url?.startsWith('https://')
		|| url?.startsWith('tel:'));

export const numberFormatter = (number: number): string =>
	new Intl.NumberFormat('nl-NL', {
		minimumFractionDigits: 2,
	})
		.format(number)
		.toString();

export const urlFormatter = (path: string) => `${process.env.BASE_URL}${path}`;
